// extracted by mini-css-extract-plugin
export default {"tags":"CyvOH","tag":"_4KrP"};